module.exports = __webpack_public_path__ + "img/95e22fb.jpg";